import React, { Component } from 'react';

import { TableLayout } from '../Menu/Stock/containers/Layout';
import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';

import NewSim from '../Menu/module/paygoNewSim'
import { isEmpty } from "lodash";
import { Table, TableRow, Grid, Button, TableHead, TableCell, TableBody, Box } from '@material-ui/core';
import SearchBarAction from './Layouts/SearchBarAction';
import { AddRounded } from '@material-ui/icons';
import PageAdmin from './Layouts/PageAdmin';


class SimsList extends Component {
    state = { 
        new: false,
        list: [],
        details: false,
        currentSIM: "",

     }
    componentDidMount = async  () => {
        const { SIMS } = this.props;
        if( !SIMS ){
            await this.props.fetchSims()
        }
        this.filterList()
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.SIMS) ){
                list = Object.keys(this.props.SIMS)
            } else {
                list = []
            }
        }

        this.setState({
            list
        })
    }
    render() {
        const { SIMS } = this.props;
        const { currentSIM, details } = this.state
        return (
            <PageAdmin title="Sims">
                {this.state.new &&
                    <NewSim 
                        popupState={"overlay"} 
                        onCloseOverlay={()=> this.setState({ new: false })}
                    />
                }
                {(details && currentSIM) &&
                   <Dialog 
                        title="Details"
                        block={details}
                        title={"Details"}
                        close={()=> this.setState({details:false, currentSIM:""}) }
                    >
                        <div className="table-responsive">
                            <Table className="table table-hover">
                                <TableBody className="text-left">
                                    {SIMS[currentSIM].other && 
                                        Object.keys(SIMS[currentSIM].other).map((key)=>(

                                            <TableRow key={key}>
                                                <TableCell>{key}</TableCell>
                                                <TableCell>{
                                                    Array.isArray(SIMS[currentSIM].other[key]) ? 
                                                    SIMS[currentSIM].other[key].join(' - ') :
                                                    SIMS[currentSIM].other[key] 
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )) 
                                    }
                                </TableBody>
                                
                            </Table>
                        </div>
                   </Dialog>
                }
                {/* <h3>SIMS</h3> */}
                <SearchBarAction list={ SIMS } filterList={this.filterList} action={ () => this.setState({ new: true }) } />
                {/* <Grid container spacing={2} >
                    <Grid item sm={3} xs={12}>
                        <Button 
                            className="btn btn-info" 
                            onClick={()=>
                                this.setState({ new: true })
                            }>Nouveau</Button>
                    </Grid>
                    <Grid item sm={9} xs={12}>
                        <SearchBar list={ SIMS } filterList={this.filterList}/>
                    </Grid>
                        
                </Grid> */}
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Opérateur</TableCell>
                            <TableCell>Numero</TableCell>
                            <TableCell>PIN</TableCell>
                            <TableCell>APN</TableCell>
                            <TableCell>Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {SIMS && 
                            this.state.list.map( ID => {
                                let sim = SIMS[ID]
                                return(
                                    <TableRow key={sim.id}>
                                        <TableCell>{ sim.operator }</TableCell>
                                        <TableCell>{ sim.numero }</TableCell>
                                        <TableCell>{ sim.pin }</TableCell>
                                        <TableCell>{ sim.apn }</TableCell>
                                        <TableCell onClick={() => this.setState({ currentSIM:sim.id, details: true })}> <AddRounded color="primary"/></TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}

export default SimsList